module.exports = __webpack_public_path__ + "images/emoji/dragon_face.1ff4f8d5b03cff9efb15.png";